/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Account_Company_MissingInputs */

const cs_social_export_account_company_missing = /** @type {(inputs: Social_Export_Account_Company_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firemní Meta není propojená. Admin ji může nastavit v Integracích.`)
};

const en_social_export_account_company_missing = /** @type {(inputs: Social_Export_Account_Company_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Meta is not connected. An admin can link it under Integrations.`)
};

/**
* | output |
* | --- |
* | "Company Meta is not connected. An admin can link it under Integrations." |
*
* @param {Social_Export_Account_Company_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_account_company_missing = /** @type {((inputs?: Social_Export_Account_Company_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Account_Company_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_account_company_missing(inputs)
	return cs_social_export_account_company_missing(inputs)
});